import React, { useEffect, useState } from 'react'
import { IoAnalyticsSharp, IoSettings } from "react-icons/io5";
import { Link } from 'react-router-dom'
import Menu from 'antd/es/menu'
import ConfigProvider from 'antd/es/config-provider'
import * as Icons from 'react-icons/lu'
import { GrDownload } from "react-icons/gr";
import { FaDownload, FaRegCalendarAlt, FaUser } from 'react-icons/fa';
import { ClipboardClock } from 'lucide-react';

export default function Sidebar(props) {

    const menu = [
        {
            "key": "1",
            "label": <Link to="/dashboard">Dashboard</Link>,
            "icon": <Icons.LuLayoutDashboard size={15} />,
            "type": '',

        },
        {
            "key": "2",
            "label": 'Master',
            "icon": <Icons.LuLayoutDashboard size={15} />,
            "type": '',
            "children": [
                {
                    key: '21',
                    icon: <Icons.LuCircleDot size={16} />,
                    label: <Link to={'/designation-list'}>Designation</Link>,
                },
                {
                    key: '22',
                    icon: <Icons.LuCircleDot size={16} />,
                    label: <Link to={'/department-list'}>Department</Link>,
                },
                {
                    key: '23',
                    icon: <Icons.LuCircleDot size={16} />,
                    label: <Link to={'/reason-list'}>Reason</Link>,
                },
                {
                    key: '24',
                    icon: <Icons.LuCircleDot size={16} />,
                    label: <Link to={'/gate-list'}>Gate</Link>,
                },
                {
                    key: '25',
                    icon: <Icons.LuCircleDot size={16} />,
                    label: <Link to={'/purpose-list'}>Purpose</Link>,
                },
                // {
                //     key: '23',
                //     icon: <Icons.LuCircleDot size={16} />,
                //     label: <Link to={'/defect-list'}>Defects</Link>,
                // }
            ]


        },
        {
            "key": "3",
            "label": <Link to="/user-list">User</Link>,
            "icon": <FaUser size={15} />,
            "type": '',

        },
        {
            "key": "4",
            "label": <Link to="/visitor-list">Visitors</Link>,
            "icon": <Icons.LuUsers2 size={15} />,
            "type": '',

        },
        // {
        //     "key": "4",
        //     "label": <Link to="/tooling-configuration">Tooling Configuration</Link>,
        //     "icon": <Icons.LuSettings size={15} />,
        //     "type": '',

        // },
        // {
        //     "key": "5",
        //     "label": <Link to="/upload-file">Upload Files</Link>,
        //     "icon": <Icons.LuUpload size={15} />,
        //     "type": '',

        // },
        // {
        //     "key": "6",
        //     "label": <Link to="/activity-log">Activity</Link>,
        //     "icon": <ClipboardClock size={15} />,
        //     "type": '',

        // },
        {
            "key": "7",
            "label": <Link to="/update-version">Update Version</Link>,
            "icon": <Icons.LuSettings size={15} />,
            "type": '',
        },

    ];


    return (
        <>

            <ConfigProvider
                theme={{
                    components: {
                        Menu: {
                            // itemPaddingInline: 12,
                            // horizontalLineHeight: '40px',
                            // itemHeight: 35,
                            // itemBg:'red',
                            // horizontalItemSelectedColor: '#ffffff',  // white color for selected menu item
                            // horizontalItemHoverColor: '#706a6aff',
                            itemSelectedColor: '#42c9c4',
                            subMenuItemSelectedColor: '#ffffff',
                            itemBg: '#42c9c4',
                            itemHoverBg: 'rgba(79, 85, 83, 0.7)',
                            itemHoverColor: '#42c9c4',
                            itemSelectedBg: '#69726fff',
                            horizontalItemSelectedColor: '#42c9c4',
                            horizontalItemHoverColor: '#706a6aff',
                            itemColor: 'white',
                            popupBg: '#17313E'
                        },
                    },
                    token: {
                        fontSize: 14,
                        fontFamily: 'Poppins',
                        colorText: '#ffffff',
                    },
                }}
            >
                <Menu
                    mode="horizontal"
                    style={{
                        background: '#0c101b',
                        marginTop: '-3px',
                        width: '100%',
                        boxShadow: ' rgba(0, 0, 0, 0.06) 0px 2px 4px 0px inset',
                        position: 'fixed',
                        zIndex: '999'
                    }}
                    items={menu}

                />
            </ConfigProvider >
        </>
    )
}
